// extracted by css-extract-rspack-plugin
export default {"link":"X1lI0"};